<template>
  <input-select
    id="state"
    :value="value"
    name="state"
    label="State"
    placeholder="Select your state..."
    :options="options"
    @input="val => $emit('input', val)"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'StatePicker',

  components: {
    InputSelect
  },

  props: {
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      options: [
        { id: 'Alabama', display_label: 'Alabama' },
        { id: 'Alaska', display_label: 'Alaska' },
        { id: 'Arizona', display_label: 'Arizona' },
        { id: 'Arkansas', display_label: 'Arkansas' },
        { id: 'California', display_label: 'California' },
        { id: 'Colorado', display_label: 'Colorado' },
        { id: 'Connecticut', display_label: 'Connecticut' },
        { id: 'Delaware', display_label: 'Delaware' },
        { id: 'District of Columbia', display_label: 'District of Columbia' },
        { id: 'Florida', display_label: 'Florida' },
        { id: 'Georgia', display_label: 'Georgia' },
        { id: 'Hawaii', display_label: 'Hawaii' },
        { id: 'Idaho', display_label: 'Idaho' },
        { id: 'Illinois', display_label: 'Illinois' },
        { id: 'Indiana', display_label: 'Indiana' },
        { id: 'Iowa', display_label: 'Iowa' },
        { id: 'Kansas', display_label: 'Kansas' },
        { id: 'Kentucky', display_label: 'Kentucky' },
        { id: 'Louisiana', display_label: 'Louisiana' },
        { id: 'Maine', display_label: 'Maine' },
        { id: 'Maryland', display_label: 'Maryland' },
        { id: 'Massachusetts', display_label: 'Massachusetts' },
        { id: 'Michigan', display_label: 'Michigan' },
        { id: 'Minnesota', display_label: 'Minnesota' },
        { id: 'Mississippi', display_label: 'Mississippi' },
        { id: 'Missouri', display_label: 'Missouri' },
        { id: 'Montana', display_label: 'Montana' },
        { id: 'Nebraska', display_label: 'Nebraska' },
        { id: 'Nevada', display_label: 'Nevada' },
        { id: 'New Hampshire', display_label: 'New Hampshire' },
        { id: 'New Jersey', display_label: 'New Jersey' },
        { id: 'New Mexico', display_label: 'New Mexico' },
        { id: 'New York', display_label: 'New York' },
        { id: 'North Carolina', display_label: 'North Carolina' },
        { id: 'North Dakota', display_label: 'North Dakota' },
        { id: 'Ohio', display_label: 'Ohio' },
        { id: 'Oklahoma', display_label: 'Oklahoma' },
        { id: 'Oregon', display_label: 'Oregon' },
        { id: 'Pennsylvania', display_label: 'Pennsylvania' },
        { id: 'Puerto Rico', display_label: 'Puerto Rico' },
        { id: 'Rhode Island', display_label: 'Rhode Island' },
        { id: 'South Carolina', display_label: 'South Carolina' },
        { id: 'South Dakota', display_label: 'South Dakota' },
        { id: 'Tennessee', display_label: 'Tennessee' },
        { id: 'Texas', display_label: 'Texas' },
        { id: 'Utah', display_label: 'Utah' },
        { id: 'Vermont', display_label: 'Vermont' },
        { id: 'Virginia', display_label: 'Virginia' },
        { id: 'Washington', display_label: 'Washington' },
        { id: 'West Virginia', display_label: 'West Virginia' },
        { id: 'Wisconsin', display_label: 'Wisconsin' },
        { id: 'Wyoming', display_label: 'Wyoming' }
      ]
    };
  }
};
</script>
